import  moment  from 'moment';

export const sortByTime=(songs,maxtime)=>{
  console.log('songs in sortByTime: ',songs);
  console.log('maxtime is: ',maxtime);
  console.log('max in minutes: ',maxtime);
  let totalSongs=(tunes)=>{
    let gigtime = [];
    let results=0;
    for (let i=0; i<tunes.length; i++){
      let timeval = tunes[i].time;
      gigtime.push(timeval);
      results+=timeval
    }
    return results;
  }
  let total = totalSongs(songs);
  //  console.log('the TOTAL: ',total);
  while(total-maxtime > 250000){
    //  console.log('popping song!');
    songs.pop();
    total = totalSongs(songs);
  }
  console.log('TOTAL MILLISECS: ',total);
  let temp = moment.duration(total);
  let final;
  if(temp.hours()>0){
    final = temp.hours() + ' hr ' + temp.minutes() + ' min '+ temp.seconds()+' sec';
  }else{
    final = temp.minutes() + ' min '+ temp.seconds()+' sec';
  }

   return songs;

 }



// WEBPACK FOOTER //
// ./src/js/sortByTime.js